import { ImportSummary } from '../../../../types/Import';

interface ImportMappingSummaryProps {
  summary: ImportSummary;
}

const SummaryRow = ({ label, found, create }: { label: string; found: number; create: number }) => (
  <div className="flex items-center py-2 border-b border-neutral-200 last:border-b-0">
    <span className="text-neutral-700 text-sm flex-1">{label}</span>
    <span className="text-brand-grey-dark text-sm font-medium w-[140px] text-right">{found}</span>
    <span className="text-brand-grey-dark text-sm font-medium w-[140px] text-right">{create}</span>
  </div>
);

export const ImportMappingSummary = ({ summary }: ImportMappingSummaryProps) => {
  return (
    <div>
      <div className="flex items-center pb-2">
        <span className="flex-1" />
        <span className="text-neutral-700 text-xs w-[140px] text-right">Found in your file</span>
        <span className="text-neutral-700 text-xs w-[140px] text-right">Create in Taskonio</span>
      </div>
      <SummaryRow label="Epics" found={summary.epicsCount} create={summary.epicsCount} />
      <SummaryRow label="Items" found={summary.itemsCount} create={summary.itemsCount} />
      <SummaryRow label="Subitems" found={summary.subitemsCount} create={summary.subitemsCount} />
      <SummaryRow label="Users" found={summary.usersCount} create={summary.usersCount} />
    </div>
  );
};
